import { Box, Typography, Button, Stack } from "@mui/material";
import { Add } from "@mui/icons-material";

interface AgendaSectionProps {
  agendaHtml?: string;
  onAddItem?: () => void;
  isAdmin?: boolean;
}

export default function AgendaSection({
  agendaHtml,
  onAddItem,
  isAdmin = false,
}: AgendaSectionProps) {
  return (
    <Box
      sx={{
        py: { xs: 4, md: 6 },
        px: { xs: 2, md: 6 },
        mt: { xs: 2, md: 6 },
        bgcolor: "#FAFBFF",
        borderRadius: 4,
      }}
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ mb: 3 }}
      >
        <Typography variant="h5" fontWeight={800}>
          Event Agenda
        </Typography>

        {isAdmin && (
          <Button
            variant="contained"
            startIcon={<Add />}
            onClick={onAddItem}
            sx={{
              textTransform: "none",
              borderRadius: 3,
              px: 3,
              py: 1.25,
              bgcolor: "#1976D2",
              fontWeight: 600,
              boxShadow: "0 4px 14px rgba(25, 118, 210, 0.4)",
              "&:hover": {
                bgcolor: "#1565C0",
                boxShadow: "0 6px 20px rgba(25, 118, 210, 0.5)",
              },
            }}
          >
            Add Agenda
          </Button>
        )}
      </Stack>

      {agendaHtml ? (
        <Box
          sx={{
            "& h1, & h2, & h3": { fontWeight: 700, mb: 1 },
            "& p": { mb: 1.5, lineHeight: 1.7 },
            "& ul": { pl: 3 },
          }}
          dangerouslySetInnerHTML={{ __html: agendaHtml }}
        />
      ) : (
        <Typography color="text.secondary">No agenda available yet.</Typography>
      )}
    </Box>
  );
}
